export const GENDERS = {
  MALE: "MALE",
  FEMALE: "FEMALE",
  MANY: "MANY",
}

export const SUGGESTION_STATES = {
  PENDING: "PENDING",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
}

export const CUSTOM_EVENTS = {
  SHOW_RESTAURANT_MENU: "SHOW_RESTAURANT_MENU",
  HIDE_RESTAURANT_MENU: "HIDE_RESTAURANT_MENU",
  SHOW_COMBINE_ORDER_MODAL: "SHOW_COMBINE_ORDER_MODAL",
  HIDE_COMBINE_ORDER_MODAL: "HIDE_COMBINE_ORDER_MODAL",
  SHOW_BACK_TO_PLAN_A_DATE_SCREEN_MODAL:
    "SHOW_BACK_TO_PLAN_A_DATE_SCREEN_MODAL",
  HIDE_BACK_TO_PLAN_A_DATE_SCREEN_MODAL:
    "HIDE_BACK_TO_PLAN_A_DATE_SCREEN_MODAL",
  SHOW_BACK_TO_RESTARAUNTS_SCREEN_MODAL:
    "SHOW_BACK_TO_RESTARAUNTS_SCREEN_MODAL",
  HIDE_BACK_TO_RESTARAUNTS_SCREEN_MODAL:
    "HIDE_BACK_TO_RESTARAUNTS_SCREEN_MODAL",
  SHOW_PARTNER_BACK_TO_PLAN_A_DATE_MODAL:
    "SHOW_PARTNER_BACK_TO_PLAN_A_DATE_MODAL",
  HIDE_PARTNER_BACK_TO_PLAN_A_DATE_MODAL:
    "HIDE_PARTNER_BACK_TO_PLAN_A_DATE_MODAL",
  SHOW_USER_CANCELLING_CHECKOUT_MODAL: "SHOW_USER_CANCELLING_CHECKOUT_MODAL",
  HIDE_USER_CANCELLING_CHECKOUT_MODAL: "HIDE_USER_CANCELLING_CHECKOUT_MODAL",
  SHOW_READY_FOR_CHECKOUT_MODAL: "SHOW_READY_FOR_CHECKOUT_MODAL",
  HIDE_READY_FOR_CHECKOUT_MODAL: "HIDE_READY_FOR_CHECKOUT_MODAL",
  SHOW_READY_PAGE_MODAL: "SHOW_READY_PAGE_MODAL",
  HIDE_READY_PAGE_MODAL: "HIDE_READY_PAGE_MODAL",
  OPEN_CHAT_POPUP: "OPEN CHAT POPUP",
  CLOSE_CHAT_POPUP: "CLOSE CHAT POPUP",
  CHAT_SHOW_UNREAD_DOT: 'SHOW UNREAD YELLOW DOT',
  CHAT_HIDE_UNREAD_DOT: 'HIDE UNREAD YELLOW DOT',
}

export const DRAFT_ADDRESS_MODES = {
  EMPTY: "EMPTY",
  EDIT: "EDIT",
  SAVE: "SAVE",
}

